export default "__VITE_ASSET__D3oqiB8e__"